import { createNS } from "@ontologies/core";

export default {
  ns: createNS("https://ontola-mash.herokuapp.com/"),
};
